// 公開ゲーム（生成ゲーム）の TURN 既定（ゲーム公開実装＆運用計画書 §22.4-2 / §22.2-3）。
//
// 生成ゲームの runtime-config は「iceServers はそのままコピー（STUN のみへ濾過）＋
// turnCredentials キーを削除」が既定（= STUN のみ・TURN なし）。TURN が必要な公開ゲームだけ
// 生成後に runtime-config へ個別付与する。llm-hub の TURN クレデンシャル発行予算（日次）と
// Cloudflare Realtime TURN の無料 1,000GB/月 は全ゲーム共有のため、既定同梱にしない。
//
// filterStunOnlyIceServers は sevenfold/js/network/ice-config.ts の同名関数（正本）と
// 同一セマンティクスの移植。公開ツールは sevenfold 内部コードを実行時参照しない規約のため、
// 実装をここへ複製し、正本の変更時は本ファイルへ同一差分を反映する。

export function filterStunOnlyIceServers(iceServers) {
    if (!Array.isArray(iceServers)) return [];
    const out = [];
    for (const server of iceServers) {
        if (!server || typeof server !== 'object') continue;
        const urls = Array.isArray(server.urls) ? server.urls : [server.urls];
        const stunUrls = urls.filter((url) => typeof url === 'string' && !/^turns?:/i.test(url));
        if (stunUrls.length === 0) continue;
        out.push({ urls: Array.isArray(server.urls) ? stunUrls : stunUrls[0] });
    }
    return out;
}

// TURN を除去した生成ゲームへ残す説明（再付与の手順を runtime-config 内に自己完結で記す）
export const TURN_OPT_IN_COMMENT = '生成ゲームの既定は STUN のみ・TURN なし（計画書§22.4-2）。'
    + 'TURN が必要な公開ゲームだけ、ここへ turnCredentials（例: {"endpoint":"https://llm-hub.voxelnovels.com/api/turn-credentials","timeoutMs":4000}）'
    + 'か、iceServers への turn:/turns: エントリを個別付与する。'
    + 'llm-hub の日次発行予算と Cloudflare TURN 無料1,000GB/月は全ゲーム共有のため付与時は費用負担を判断すること（§20.2-11）。';

/**
 * 生成ゲームの runtime-config オブジェクトへ TURN 既定を適用する（in-place）。
 * - systems.multiplayer.turnCredentials キーを削除
 * - systems.multiplayer.iceServers を STUN のみへ濾過
 * - TURN を除去した場合のみ _turnCredentialsComment を再付与手順の説明へ置換
 * multiplayer キー自体が無い・型が不正な場合は何もしない（キー欠損=現行動作の契約を壊さない）。
 * @returns {{changed: boolean, removedTurnCredentials: boolean, iceServersBefore: number|null, iceServersAfter: number|null}}
 */
export function applyPublicGameTurnDefaults(runtimeConfig) {
    const result = { changed: false, removedTurnCredentials: false, iceServersBefore: null, iceServersAfter: null };
    const mp = runtimeConfig?.systems?.multiplayer;
    if (!mp || typeof mp !== 'object' || Array.isArray(mp)) return result;

    if (Object.prototype.hasOwnProperty.call(mp, 'turnCredentials')) {
        delete mp.turnCredentials;
        result.removedTurnCredentials = true;
        result.changed = true;
    }

    if (Array.isArray(mp.iceServers)) {
        result.iceServersBefore = mp.iceServers.length;
        const filtered = filterStunOnlyIceServers(mp.iceServers);
        result.iceServersAfter = filtered.length;
        if (JSON.stringify(filtered) !== JSON.stringify(mp.iceServers)) {
            mp.iceServers = filtered;
            result.changed = true;
        }
    }

    if (result.changed) {
        mp._turnCredentialsComment = TURN_OPT_IN_COMMENT;
    }
    return result;
}
